module.exports = __webpack_public_path__ + "383a4df99cd10ac7b57c18aaadead8be.svg";